// 英文库  zh_cn与 en_us的key值需要保持一致
// 需要双语切换的部分用  $t('字段名')  取值，如 <div>{{ $t('table.home') }}</div>，在script代码中用  this.$t('字段名')  取值
export default {
  bottomLink: {
    address: 'Add: 312, Building B, Huafeng Zhigu Fuhai Science and Technology Industrial Park, Fuhai Street, Baoan District, Shenzhen City',
    phone: 'Tel: 0755-23204571',
    email: 'Email: faraday@faradayed.com',
    companyName: 'Shenzhen Faraday ePower Drive Co., Ltd.',
    addressMobile: 'Add: Room B312, Building B, Huafeng Zhigu Technology Industrial Park, Fuhai Street, Baoan District, Shenzhen, Guangdong, China',
  },
  table: {
    label: 'English',
    home: 'Home',
    about: 'About Faraday',
    quality: 'Quality Assurance',
    product: 'Product Center',
    expcenter: 'Experimental Center',
    case: 'Application Cases',
    download: 'Downloads',
    news: '',
    service: '',
    contact: 'Contact Us',
    companyName: 'Shenzhen Faraday ePower Drive Co., Ltd.',
    visible: 'display:none',  //有些模块中文页面有而英文页面没有，设置css属性，中文不做处理，英文设置元素不显示。
    visible2: '',
  },
  home: {
    title: 'Faraday-Focus on R&D, production and sales of new energy motor drive systems',
    fldTitle: 'Shenzhen Faraday ePower Drive Co., Ltd.',
    introduce: 'Shenzhen Faraday ePower Drive Co., Ltd. is located in the coastal city of Shenzhen, which is known as the "Design Capital" and "Innovation City". Focusing on the fields of new energy vehicles and industrial automation, it is a "national high-tech enterprise" with completely independent intellectual property rights and specializing in the R&D, manufacturing, sales and services of power electronic products such as new energy vehicle motor drivers, professional inverters, and general inverters.',
    fldTitleStyle: 'font-size:1.8vw;line-height:110%;margin-bottom:0;',
    introduceStyle: 'line-height:1.7vw;',
    introduceStyleMobile: 'font-size:13px;line-height:20px;letter-spacing: 0px;',
    moreCase: 'More cases',
    moreCaseStyle: '',
    textPic: 'text1-en.png'
  },
  about: {
    tab1: 'Company Profile',
    tab2: 'Company Environment',
    tab3: 'Corporate Culture',
    tab4: 'Company Honors',
    tab5: 'Organizational Structure',
    para1: 'Shenzhen Faraday ePower Drive Co., Ltd. is located in the coastal city of Shenzhen, which is known as the "Design Capital" and "Innovation City". Focusing on the fields of new energy vehicles and industrial automation, it is a "national high-tech enterprise" with completely independent intellectual property rights and specializing in the R&D, manufacturing, sales and services of power electronic products such as new energy vehicle motor drivers, professional inverters, and general inverters.',
    para2: 'Shenzhen Faraday ePower Drive Co., Ltd. adheres to the concept of "scientific and technological innovation, talent-driven enterprises" and has a team of talents with strong technology and high comprehensive quality.',
    para3: 'Shenzhen Faraday ePower Drive Co., Ltd. and its products have passed or obtained ISO9001:2008, IATF16949 quality management system certification for the automotive industry, CCS certification for electric boat drive products, EMC certification by national authoritative institutions, national compulsory inspection and certification, national high-tech enterprise certification, CNAS laboratory accreditation, ISO14001 environmental management system certification, etc.',
    para4: 'Serving customers and running products on the market for millions of units, more than 50% of the products have met the quality assurance requirements and maintained good operation, and have been tested, recognized and favored by the market. ',
    para5: 'Shenzhen Faraday ePower Drive Co., Ltd. has a product experience model of selling one generation, developing one generation, and pre-researching one generation, and the technology iteration has achieved the transition from following to leading. ',
    para6: 'Facing the era of new energy vehicle consumption in China that is about to be detonated, the company actively participates in the research and development, production and sales of new energy vehicle motor drivers, helping customers provide energy-saving, efficient and high-quality system solutions. ',
    para7: "Shenzhen Faraday ePower Drive Co., Ltd. has mastered core competitiveness and actively participated in the green transformation of the national steel, petrochemical, chemical, nonferrous, building materials, textile, papermaking, leather and other industries, enhancing China's high-performance special machine inverter supply capacity, breaking the long-term monopoly of high-performance special machine inverters by international giants, and simultaneously developing high-performance special machine inverters and general inverter product research and development, production and sales. ",
    para8: "Shenzhen Faraday ePower Drive Co., Ltd.'s manufacturing base is located in Qilongshan Industrial Park, Jingmian 2nd Road, Cunruan Town, Pengjiang District, Jiangmen City, Guangdong Province, China. The Qilongshan Industrial Park New Energy Base covers an area of ​​200 acres and has an investment of 2 billion yuan. It specializes in the research and development, production and manufacturing of new energy vehicle motor controllers, professional inverters, general inverters, AC & DC charging piles, on-board micro-charging piles, on-board circulating cooling water pumps, and heating pump systems. ",
    para9: 'Qilongshan Industrial Park integrates office buildings, dormitory buildings, senior talent rooms, conferences, exhibition halls, hotels, and restaurant services, with a unified overall style, and a total of 8 buildings.',
    env1: 'Company front desk',
    env2: 'Product testing',
    env3: 'Marketing center',
    env4: 'R&D center',
    env5: 'Production workshop',
    env6: 'Production workshop',
    env7: 'Production workshop',
    env8: 'Production workshop',
    env9: 'Products to be aged',
    env10: 'Product aging',
    cul1: "Faraday's principles of work and employment",
    cul2: "",
    cul3: "Working principles: today's work should be completed today;",
    cul4: "Employment principles: everyone is a talent, the one who is suitable is the talent, not academic qualifications but efforts;",
    cul5: "Faraday's product philosophy",
    cul6: 'Quality is life, reputation is soul,',
    cul7: 'Innovation is motivation, responsibility is future',
    cul8: "Faraday's business philosophy",
    cul9: 'Serving the terminal, being close to the market,',
    cul10: 'protecting the channels, and achieving a win-win situation.',
    cul11: "Faraday's continuous spirit",
    cul12: 'Diligence: hard work, diligence, thrift, personally visit the scene, set an example;',
    cul13: 'Thrift: simplicity, thrift, self-thrift, hard work and simplicity to save every penny;',
    cul14: 'Family: country, big family, small family, strengthen the country, prosper the big family, prosper the small family.',
    cul15: "Faraday's working spirit",
    cul16: 'The spirit of never giving up in the face of difficulties, the spirit of doing a good job to the end;',
    cul17: 'The spirit of confronting problems head-on, the spirit of never giving up to improve efficiency.',
    cul18: `Faraday's "Three Honors and One Trust"`,
    cul19: 'First Honor: The company is proud of its excellent partners.',
    cul20: 'Second Honor: The partners are proud of the developing company.',
    cul21: 'Third Honor: The manufacturer, the business, and the user are proud of harmonious win-win.',
    cul22: 'One Trust: The manufacturer and the user trust each other and trust the product.',
    cert1: 'Invention Patent Certificate',
    cert2: 'Software Copyright',
    cert3: 'Utility Patent Certificate',
    organization: 'IMG20240506-085844909-en.png',
    mainTextStyle: '',
  },
  product: {
    visible: 'display: none',
    visible2: '',
    tab1: 'Vehicle Motor Controller',
    tab2: 'Dedicated Purpose Inverter',
    tab3: 'General Purpose Inverter',
    fed18: 'FED-18 Series',
    fed20: 'FED-20 Series',
    fed21: 'FED-21 Series',
    fed22: 'FED-22 Series',
    fed23: 'FED-23 Series',
    fd22: 'FD22 series high protection level liquid-cooled dedicated drives',
    fd22s: 'FD22-S series high protection level liquid-cooled general purpose inverter',
    e130: 'E130 series high reliability general purpose vector inverters',
    titleStyle: 'font-size:25px',
    fd22Para1: 'Input voltage: 350VDC~750VDC.',
    fd22Para2: 'Power range: 55kW~280kW.',
    fd22Para3: 'Overload capacity: 150% load for 60s,180% load for 3s.',
    fd22Para4: 'Control mode: VF,SVC,FVC.',
    fd22Para5: 'Drive motor: Assynchronous motor, Permanent magnet synchronous motor.',
    fd22Spec: 'FD22 Series Model Specifications:',
    fd22sPara1: 'Input voltage: 340VAC-10%~460VAC + 10%.',
    fd22sPara2: 'Power range: 75KW~560KW.',
    fd22sPara3: 'Overload capacity: 150% load for 60s, 180% load for 3s.',
    fd22sPara4: 'Control mode: VF,SVC,FVC.',
    fd22sPara5: 'Drive motor: Assynchronous motor, Permanent magnet synchronous motor.',
    fd22sSpec: 'FD22-S Series Model Specifications:',
    e130Para1: 'Input voltage: 340VAC-10%~460VAC+10%.',
    e130Para2: 'Power range: 0.75KW~160KW.',
    e130Para3: 'Overload capacity: 150% rated load 60s, 180% rated load 3s.',
    e130Para4: 'Control mode: VF,and SVC.',
    e130Para5: 'Drive motor: Frequency converter asynchronous motor, Permanent magnet synchronous motor.',
    e130Spec: 'E130 Series Model Specifications:',
    e100: 'E100 Series General purpose vector inverter',
    e100Para1: 'Input voltage: Three-phase AC380V;single phase AC220V;three-phase AC220V',
    e100Para2: 'Power range: Three-phase 0.75KW~200KW;   single phase 0.4KW~4.0KW.',
    e100Para3: 'Overload capacity: 150% rated load for 60s, 180% rated load for 3s.',
    e100Para4: 'Control mode: VF、SVC.',
    e100Para5: 'Drive motor: Assynchronous motor, Permanent magnet synchronous motor .',
    e100Spec: 'E100 Series Model Specifications:',
    e100b: 'E100 Series General purpose vector inverter',
    e100bPara1: 'Input voltage: three-phase AC380V;single phase AC220V;three-phase AC220V.',
    e100bPara2: 'Power range: three-phase 0.75KW~200KW;   single phase 0.4KW~4.0KW.',
    e100bPara3: 'Overload capacity: 150% rated load for 60s, 180% rated load for 3s.',
    e100bPara4: 'Control mode: VF、SVC.',
    e100bPara5: 'Drive motor: Assynchronous motor, Permanent magnet synchronous motor ',
    e100bSpec: 'E100 Series Model Specifications:',
    e200: 'E200 Series high performance closed loop frequency inverter',
    e200Para1: 'Input voltage: three-phase AC380V',
    e200Para2: 'Power range: 0.75KW~500KW',
    e200Para3: 'Overload capacity: G-type: 150% rated load for 60s, 180% rated load for 3s. P-type: 120% rated load for 60s, 150% rated load for 3s.',
    e200Para4: 'Control mode: VF、SVC、FVC',
    e200Para5: 'Drive motor: Assynchronous motor, Permanent magnet synchronous motor',
    e200Spec: 'E200 Series Model Specifications:',
  },
  expcenter: {
    para1: 'The experimental center began expansion and renovation on April 15, 2021 and was completed on May 15. It covers an area of ​​1,390 square meters. There are 4 functional rooms on the first floor, 7 high-speed towing test benches for automobiles (including the Shenzhen R&D Center), 3 high-speed automobile dynamometers, 17 functional rooms on the second floor, electronic water pump flow laboratory, durability laboratory, environmental laboratory, electromagnetic compatibility laboratory, semi-anechoic room, three comprehensive vibration laboratories, heat resistance laboratory, RoHS laboratory, salt spray laboratory, waterproof and dustproof laboratory, charging gun functional performance laboratory, etc.',
    para2: "The experimental center successfully passed the review of the China National Accreditation Service for Conformity Assessment (hereinafter referred to as: CNAS) in November 22, and issued a CNAS laboratory accreditation certificate. It marks CNAS's recognition of the laboratory capabilities of the FARDAYED Testing Center, increases customer trust in the laboratory, and enhances the laboratory's core competitiveness in the testing market. The CANS coverage rate is over 85%.",
    para3: 'FARADAYER fully learns advanced testing technologies, specifications and experiences, gradually establishes a world-class professional testing and evaluation laboratory, and becomes one of the benchmark companies in the world for professional testing and evaluation of high-voltage "electronic control" technologies.',
    title1: 'Laboratory Qualification',
    title2: 'Jiangmen Experimental Center',
    title3: 'Shenzhen R&D Laboratory Center',
    title4: 'Experimental Capabilities',
    title5: 'Experimental equipment',
    title6: 'Comprehensive durability test',
    title7: 'Environmental Experiments',
    title8: 'Protection experiment',
    title9: 'Three comprehensive vibration experiments',
    title10: 'Salt spray test',
    title11: 'Reliability experiments',
    title12: 'EMS Experiment',
    title13: 'EMI test',
    title14: 'Safety test',
    title15: 'Flow head performance test system',
    title16: 'Air tightness, static pressure, tension test',
  },
  case: {
    caseTextStyle: 'font-size: 12px;',
    case1: 'Kowtowing machine',
    case2: 'Crane hoist',
    case3: 'Spindle positioning control',
    case4: 'Dyeing machine',
    case5: 'Spindle positioning gantry machine',
    case6: 'Die casting machine',
    case7: 'Twin screw extruder',
    case8: 'Coca-Cola bottling equipment',
    case9: 'Spinning machine',
    case10: 'Centrifuge',
    case11: 'Direct feed wire drawing machine',
    case12: 'Film blowing machine',
    case13: 'Plastic wire drawing machine',
    case14: 'Welding mesh machine',
    case15: 'Marble cutting equipment',
    case16: 'Slitting machine',
    case17: 'Marine electric propulsion drive system applications',
    case18: 'Industrial energy saving retrofit system applications',
    case19: 'FD series industrialized applications',
    case20: 'Commercial vehicle electrification applications',
    case21: 'Commercial vehicle electrification applications',
    case22: 'Commercial vehicle electrification applications',
    case23: 'Commercial vehicle electrification applications',
    case24: 'Marine electric propulsion drive system applications',
    application1: 'Slitting machine tension control system solution',
    application2: 'Automatic winding machine application',
    application3: 'Laminating machine tension control system solution',
    application4: 'Cold rolling mill solution',
  },
  img: {
    banner: {
      banner1: 'banner1蓝底-en.png',
      banner2: 'banner2蓝底-en.png',
      banner3: 'banner3蓝底-en.png',
      banner1b: 'qilongshan3.jpg',
      banner2b: 'qilongshan2.jpg',
      banner3b: 'qilongshan4.jpg',
      bannerProduct1: 'product-banner1-en.jpg',
      bannerProduct2: 'product-banner2-en.jpg',
    },
    home: {
      pic1: '资源 12-8改2-en.png',
      pic2: '资源 13-8改-en.png',
      pic3: '资源 14-8改-en.png',
    },
    quality: {
      pic1: 'quality-1-en.png ',
      pic2: 'quality-2-en.png ',
      pic3: 'quality-3-en.png ',
      pic4: '',
      pic5: '',
      pic6: 'quality-6-en.png ',
      pic7: 'quality-7-en.png ',
      pic8: 'quality-8-en.png ',
      pic9: 'quality-9-en.png ',
      pic10: 'quality-10-en.png',
      pic11: 'quality-11-en.png',
      pic12: 'quality-12-en.png',
      pic13: 'quality-13-en.png',
      pic14: 'quality-14-en.png',
    },
    product: {
      fed18: '20240506185058-en.png',
      fed20: 'FED20-ALL-en.png',
      fed21: 'FED21-ALL-en.png',
      fed22: 'FED22-ALL-en.png',
      fed23: 'FED21-4-en.png',
      fd22_1: '图片5-en.png',
      fd22_2: '20240506171853-en.png',
      fd22s_1: '图片4-en.png',
      fd22s_2: '20240506165727-en.png',
      e130: 'E130-1-en.png',
      e100_1: 'e100-inverter-en.png',
      e100_2: 'e100-detail1-en.png',
      e100_3: 'e100-detail2-en.png',
      e100b_1: 'e100b-inverter-en.png',
      e100b_2: 'e100b-detail1-en.png',
      e100b_3: 'e100b-detail2-en.png',
      e200_1: 'e200-inverter-en.png',
      e200_2: 'e200-detail1-en.png',
      e200_3: 'e200-detail2-en.png',
    },
    expcenter: {
      pic1: 'exp-1.png',
      pic2: 'exp-2-en.png',
      pic3: 'exp-3.png',
      pic4: 'exp-4-en.png',
      pic5: 'exp-5-en.png',
      pic6: 'exp-6-en.png',
      pic7: 'exp-7-en.png',
      pic8: 'exp-8-en.png',
      pic9: 'exp-9-en.png',
      pic10: 'exp-10-en.png',
      pic11: 'exp-11-en.png',
      pic12: 'exp-12-en.png',
      pic13: 'exp-13-en.png',
      pic14: 'exp-14-en.png',
      pic15: 'exp-15-en.png',
      pic16: 'exp-16-en.png',
      pic17: 'exp-17改-en.png',
      pic18: 'exp-18-en.png',
      pic19: 'exp-19-en.png',
      pic20: 'exp-20-en.png',
      pic21: 'exp-21-en.png',
    },
    case: {
      pic1: 'case-24-1-en.png',
      pic2: 'case-17-1-en.png',
      pic3: 'case-18-1-en.png',
      pic4: 'case-19-1-en.png',
      pic5: 'case-20-1-en.png',
      pic6: 'case-21-1-en.png',
      pic7: 'case-22-1-en.png',
      pic8: 'case-23-1-en.png',
    }
  },
  download: {
    tab1: 'Vehicle Motor Controller',
    tab2: 'General Purpose Inverter',
    tab3: 'Dedicated Purpose Inverter',
    visible: 'display:none',
    visible2: '',
    type1: {
      file1: {
        name: 'Frequently Asked Questions about Frequency Inverters.docx',
        type: 'File Type: docx',
        size: 'File Size: 2.28MB',
        url: 'files/E601S product manual.docx',
      },
      file2: {
        name: 'Introduction to the testing capacity of Faraday Testing Center - 2024.5 ',
        type: 'File Type: pptx',
        size: 'File Size: 19.1MB',
        url: 'files/广东汉宇集团-法拉第检测中心试验能力介绍-2024.5 英文版.pptx',
      },
      file3: {
        name: '',
        type: '',
        size: '',
        url: '',
      }
    },
    type3: {
      file1: {
        name: 'FD22 Series inverter Hardware Manual.pdf',
        type: 'File Type: pdf',
        size: 'File Size: 730KB',
        url: 'files/FD22 Series inverter Hardware Manual.pdf',
      },
      file2: {
        name: 'FD22-S Series Of Inverter Hardware Manual.pdf',
        type: 'File Type: pfd',
        size: 'File Size: 1.65MB',
        url: 'files/FD22-S Series Of Inverter Hardware Manual.pdf',
      },
      file3: {
        name: 'FD22-S&&FD22 Series Inverter debugging manual.pdf',
        type: 'File Type: pdf',
        size: 'File Size: 3MB',
        url: 'files/FD22-S&&FD22 Series Inverter debugging manual.pdf',
      },
      file4: {
        name: 'Frequently Asked Questions about Frequency Inverters.docx',
        type: 'File Type: docx',
        size: 'File Size: 276KB',
        url: 'files/Frequently Asked Questions about Frequency Inverters.docx',
      }
    },
    type2: {
      file1: {
        name: 'E601S product manual.docx',
        type: 'File Type: docx',
        size: '2.28MB',
        url: 'files/E601S product manual.docx'
      }
    }
  },
  contact: {
    visible: 'display:none',
    visible2: ''
  }
}


// WEBPACK FOOTER //
// ./src/lang/en_us.js